export default __webpack_public_path__ + "static/media/tistio-ZO0weaaDrBs-unsplash.86dd4dbd.jpg";